module.exports = __webpack_public_path__ + "static/media/spinner.bcf947cd.gif";